module.exports = __webpack_public_path__ + "static/icon-button-599b6d48890a2f77187f0cc4a4d12fda.png";